import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { CustomerAddressTypeEnum } from 'src/app/models/customer-address/customer-address-type-enum';
import { QuoteEditNavigationState } from 'src/app/models/quote/quote-edit-navigation-state';
import { RecommendationEditNavigationState } from 'src/app/models/recommendation/recommendation-edit-navigation-state';
import { RecommendationEquipmentEditNavigationState } from 'src/app/models/recommendation/recommendation-equipment-edit-navigation-state';
import { SearchResultCustomerAddress } from 'src/app/models/search/search-result-customer-address';
import { SearchResultEquipment } from 'src/app/models/search/search-result-equipment';
import { SearchResultQuote } from 'src/app/models/search/search-result-quote';
import { SearchResultRecommendation } from 'src/app/models/search/search-result-recommendation';
import { SearchResults } from 'src/app/models/search/search-results';
import { SurveyProspectCustomerAddressViewNavigationState } from 'src/app/models/survey-customer-address/survey-prospect-customer-address-view-navigation-state';
import { SurveyEquipmentEditNavidationState } from 'src/app/models/survey-equipment/survey-equipment-edit-navidation-state';
import { ToastControllerWrapperService } from 'src/app/services/toast-controller-wrapper/toast-controller-wrapper.service';
import { PermissionCheckerService } from '../../../services/permission-checker/permission-checker.service';

@Component({
  selector: 'app-search-results',
  templateUrl: './search-results.page.html',
  styleUrls: ['./search-results.page.scss'],
})
export class SearchResultsPage implements OnInit {

  title: string = 'Search Results';
  searchResults: SearchResults;
  canCRUDQuotes: boolean;
  canCRUDRecommendations: boolean;

  constructor(
    private router: Router,
    private navController: NavController,
    private titleService: Title,
    private toastWrapper: ToastControllerWrapperService,
    private permissionChecker: PermissionCheckerService
  ) {
    this.searchResults = <SearchResults>this.router.getCurrentNavigation().extras.state;
    if (!this.searchResults) {
      this.navController.navigateRoot(['']);
    }
  }

  ngOnInit() {
    
  }

  async ionViewWillEnter() {
    this.titleService.setTitle(this.title);
    this.canCRUDQuotes = await this.permissionChecker.canCRUDQuotes();
    this.canCRUDRecommendations = await this.permissionChecker.canCRUDRecommendations();
  }

  goToRecommendation(recommendation: SearchResultRecommendation) {
    if (recommendation.customerAndAddressExist) {
      this.router.navigate(['recommendation', recommendation.id], {
          state: <RecommendationEditNavigationState>{
            recommendationId: recommendation.id,
            addressId: recommendation.customerAddressId,
          addressType: recommendation.customerAddressType
        }
      });
    }
    else {
      this.toastWrapper.presentErrorToast('Customer/Address not found.');
    }
  }

  goToQuoteEdit(quote: SearchResultQuote) {
    if (quote.customerAndAddressExist) {
      this.router.navigate(['quote', quote.id], {
        state: <QuoteEditNavigationState>{
          quoteId: quote.id,
          addressId: quote.addressId,
          addressType: quote.addressType
        }
      });
    }
    else {
      this.toastWrapper.presentErrorToast('Customer/Address not found.');
    }
  }

  goToSurveyEquipment(equipment: SearchResultEquipment) {
    switch (equipment.addressType) {
      case CustomerAddressTypeEnum.SURVEY_PROSPECT_CUSTOMER_ADDRESS:
        this.router.navigate(['survey-prospect-customer-address-view', equipment.addressId, 'survey-equipment', equipment.id],
          {
            state: <SurveyEquipmentEditNavidationState>{
              equipmentId: parseInt(equipment.id),
              surveyCustomerAddressId: parseInt(equipment.addressId),
            }
          });
        break;
      case CustomerAddressTypeEnum.EXISTING_CUSTOMER_ADDRESS:
        let addressId = `${equipment.customerNumber}-${equipment.addressCode}`;
        this.router.navigate(['customer-address-view', equipment.addressType, addressId, 'survey-equipment', equipment.id],
          {
            state: <SurveyEquipmentEditNavidationState>{
              equipmentId: parseInt(equipment.id),
              addressId: addressId,
              addressType: equipment.addressType
            }
          });
        break;
      default:
        throw `Invalid address type: ${equipment.addressType}`;
    }
  }

  goToPendingEquipment(equipment: SearchResultEquipment) {
    if (!equipment.addressType) {
      this.toastWrapper.presentErrorToast('Invalid adress type');
    }
    this.router.navigate(['customer-address-view', equipment.addressType, equipment.addressId, 'equipment', equipment.id],
      {
        state: <RecommendationEquipmentEditNavigationState>{
          equipmentType: equipment.entitytype,
          equipmentId: equipment.id,
          addressId: equipment.addressId,
          addressType: equipment.addressType
        }
      });
  }

  goToExistingEquipment(equipment: SearchResultEquipment) {
    if (!equipment.addressType) {
      this.toastWrapper.presentErrorToast('Invalid adress type');
    }
    this.router.navigate(['customer-address-view', equipment.addressType, equipment.addressId, 'equipment', equipment.id],
      {
        state: <RecommendationEquipmentEditNavigationState>{
          equipmentType: equipment.entitytype,
          equipmentId: equipment.id,
          addressId: equipment.addressId,
          addressType: equipment.addressType
        }
      });
  }

  goToSurveyCustomerAddress(address: SearchResultCustomerAddress) {
    this.router.navigate(['survey-prospect-customer-address-view', address.id], {
      state: <SurveyProspectCustomerAddressViewNavigationState> {
        addressId: parseInt(address.id)
      }
    })
  }
}
